/**
 * Registers the service worker, and stays out of the way when it cannot.
 *
 * Only in production builds: in `vite dev` a worker would serve a cached shell
 * over the dev server's hot reload, which is a confusing hour for whoever hits
 * it. Only on a secure origin, because that is the only place the API exists —
 * a session shared over the local network runs on plain http, and there the
 * app simply works without one.
 *
 * Every failure is swallowed. A service worker is an enhancement; an
 * unregistrable one must not stop the app from starting.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;
  // `isSecureContext` covers https and localhost, which is exactly the set of
  // origins where registration can succeed at all.
  if (!window.isSecureContext) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Blocked by policy, an unsupported browser, a 404 on a partial deploy —
      // none of which the person using the app can do anything about.
    });
  });
}
